import { render, staticRenderFns } from "./Cluster.vue?vue&type=template&id=612b6654&scoped=true&"
import script from "./Cluster.vue?vue&type=script&lang=ts&"
export * from "./Cluster.vue?vue&type=script&lang=ts&"
import style0 from "./Cluster.vue?vue&type=style&index=0&id=612b6654&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612b6654",
  null
  
)

export default component.exports